import {
  resolvePhieuNhapKhoUpdateCapabilities,
  type PhieuNhapKhoEditState,
  type PhieuNhapKhoUpdateCapabilities,
} from '@/types/phieu-nhap-kho-update';
import type { IPhieuNhapKhoResponseBase } from '@/core/interfaces/ApiResponses';
import { computed, ref, type Ref } from 'vue';

export function mapPhieuNhapDetailToEditState(
  detail: IPhieuNhapKhoResponseBase & {
    can_edit?: boolean;
    lock_reason?: string | null;
  }
): PhieuNhapKhoEditState {
  const ngayHoanThanh = detail.ngay_hoan_thanh
    ? String(detail.ngay_hoan_thanh).slice(0, 10)
    : null;

  return {
    can_edit: detail.can_edit ?? !detail.is_approved,
    lock_reason: detail.lock_reason ?? null,
    is_approved: detail.is_approved,
    hoan_thanh: Boolean(detail.hoan_thanh),
    ngay_hoan_thanh: ngayHoanThanh,
    processing_status: detail.processing_status ?? null,
  };
}

export function usePhieuNhapKhoUpdateContext(
  isCreating: Ref<boolean>
) {
  const editState = ref<PhieuNhapKhoEditState | null>(null);

  const updateCapabilities = computed<PhieuNhapKhoUpdateCapabilities>(() => {
    if (isCreating.value) {
      return resolvePhieuNhapKhoUpdateCapabilities(null);
    }

    return resolvePhieuNhapKhoUpdateCapabilities(editState.value);
  });

  const canEditBbknHeaders = computed(
    () => isCreating.value || updateCapabilities.value.canEditHeaders
  );

  const canEditChiTiet = computed(
    () => isCreating.value || updateCapabilities.value.canEditChiTiet
  );

  const canEditPhieuNhapHeaders = computed(
    () => isCreating.value || updateCapabilities.value.canEditHeaders
  );

  const isFormLocked = computed(
    () =>
      !isCreating.value &&
      !updateCapabilities.value.canEditHeaders &&
      !updateCapabilities.value.canEditChiTiet
  );

  function setEditStateFromDetail(
    detail: IPhieuNhapKhoResponseBase & {
      can_edit?: boolean;
      lock_reason?: string | null;
    }
  ) {
    editState.value = mapPhieuNhapDetailToEditState(detail);
  }

  return {
    editState,
    updateCapabilities,
    canEditBbknHeaders,
    canEditChiTiet,
    canEditPhieuNhapHeaders,
    isFormLocked,
    setEditStateFromDetail,
  };
}
